import { StatusTagSeverity } from '../../shared/ui/status-tag/app-status-tag';

// Statuts de PropertyStatus (property-api), dans l'ordre du cycle de vie d'une annonce.
export const PROPERTY_STATUSES = ['DRAFT', 'PENDING_REVIEW', 'PUBLISHED', 'REJECTED', 'TAKEN', 'EXPIRED'] as const;
export type PropertyStatus = typeof PROPERTY_STATUSES[number];

export const PROPERTY_TYPES = ['APPARTEMENT', 'MAISON', 'VILLA', 'TERRAIN', 'BUREAU', 'LOCAL_COMMERCIAL', 'ENTREPOT', 'HOTEL'];

const STATUS_LABELS: Record<string, string> = {
  DRAFT: 'Brouillon', PENDING_REVIEW: 'En attente', PUBLISHED: 'Publié',
  REJECTED: 'Rejeté', TAKEN: 'Pris', EXPIRED: 'Expiré'
};

const STATUS_SEVERITIES: Record<string, StatusTagSeverity> = {
  DRAFT: 'secondary', PENDING_REVIEW: 'warn', PUBLISHED: 'success',
  REJECTED: 'danger', TAKEN: 'info', EXPIRED: 'secondary'
};

const TYPE_LABELS: Record<string, string> = {
  APPARTEMENT: 'Appartement', MAISON: 'Maison', VILLA: 'Villa',
  TERRAIN: 'Terrain', BUREAU: 'Bureau', LOCAL_COMMERCIAL: 'Local',
  ENTREPOT: 'Entrepôt', HOTEL: 'Hôtel'
};

export const propertyStatusLabel    = (s: string): string => STATUS_LABELS[s] ?? s;
export const propertyStatusSeverity = (s: string): StatusTagSeverity => STATUS_SEVERITIES[s] ?? 'secondary';
export const propertyTypeLabel      = (t: string): string => TYPE_LABELS[t] ?? t;
